import { render, staticRenderFns } from "./VDetail.vue?vue&type=template&id=c1bcbd7a&scoped=true"
import script from "./VDetail.vue?vue&type=script&lang=js"
export * from "./VDetail.vue?vue&type=script&lang=js"
import style0 from "./VDetail.vue?vue&type=style&index=0&id=c1bcbd7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bcbd7a",
  null
  
)

export default component.exports